module.exports = __webpack_public_path__ + "img/sc_logo.977a9d2b.jpg";